import logo from "@/assets/logo.png";

export const LogoWatermark = () => {
  return (
    <div
      className="fixed inset-0 z-0 flex items-center justify-center pointer-events-none"
      data-testid="logo-watermark"
    >
      <img
        src={logo}
        alt=""
        aria-hidden="true"
        className="logo-float logo-glow w-[70vw] max-w-[620px] sm:w-[48vw] select-none"
      />
    </div>
  );
};
